import { ColumnType } from 'antd/es/table';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation, useNavigate } from "react-router-dom";
import { projectsApis } from "../../api/projects";
import dayjs from "dayjs";
import { TooltipComponent } from "../../components/Component";
import { tasksApis } from '../../api/NewTasks';

const TaskIssueTracker = () => {
    const [statusFilterData, setStatusFilterData] = useState([]);
    const [ownerFilterData, setOwnerFilterData] = useState([]);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { id: projectId, projectName, derivedProjectStatus } = location.state || {};

    const columns: ColumnType<any>[] = [
        {
            title: "Task Name",
            dataIndex: "taskName",
            key: "taskName",
            width: 150,
            render(text: any, record: any) {
                return (
                    <>
                        <span
                            className="inlineTableCellLink"
                            id={`task-${record?.taskId}`}
                            onClick={() => {
                                console.log("Task Name Clicked:");
                                navigate(`/pms/project/task-detail/${record.taskId}`, {
                                    state: {
                                        projectId,
                                        projectName,
                                        returnPath: location.pathname,
                                        returnState: location.state,
                                    },
                                });
                            }}
                        >
                            {text}
                        </span>
                        <TooltipComponent
                            iconClass="info-circle text-info"
                            icon={""}
                            id={`task-${record?.taskId}`}
                            direction="right"
                            text={"Click To View " + text + " Details"}
                            containerClassName={"mt-1"}
                        />
                    </>
                );
            },
        },
        {
            title: "Issue Title",
            dataIndex: "issueName",
            key: "issueName",
            width: 100,
            render(text: any, record: any) {
                return (
                    <>
                        <span
                            className="inlineTableCellLink"
                            id={`issue-name-${record?.issueId}`}
                            onClick={(e) => {
                                e.stopPropagation(); // Add this to prevent event bubbling
                                navigate(`/pms/project/issue-detail/${record?.issueId}`, {
                                    state: {
                                        projectId: record?.projectId || projectId,
                                        projectName: record?.projectTitle || projectName,
                                        issueId: record?.issueId,
                                        issueName: record?.issueName,
                                        returnPath: location.pathname,
                                        returnState: location.state,
                                    },
                                });
                            }}
                            style={{ cursor: 'pointer' }} // Make it clear it's clickable
                        >
                            {record?.issueName || "Demo Issue Name"}
                        </span>
                        <TooltipComponent
                            iconClass="info-circle text-info"
                            icon={""}
                            id={`issue-name-${record?.issueId}`}
                            direction="right"
                            text={"Click To View and Edit " + record?.issueName + " Details"}
                            containerClassName={"mt-1"}
                        />
                    </>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "issueStatus",
            key: "issueStatus",
            width: 50,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Priority High",
            dataIndex: "issuePriority",
            key: "issuePriority",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Raised On",
            dataIndex: "raisedOn",
            key: "raisedOn",
            width: 100,
            render: (text: string) => text || "N/A"
        },
        {
            title: "Resolved On",
            dataIndex: "resolvedOn",
            key: "resolvedOn",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Assigned To",
            dataIndex: "assignedto",
            key: "assignedto",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            key: "remarks",
            width: 100,
            render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
        },


    ]

    const fetchStatusFilterData = async () => {
        try {
            const response = await projectsApis.fetchStatusFiltersByModule("Issue");
            const { data, status } = response;
            if (status) {
                const options = data.map((item: any) => {
                    return {
                        label: item,
                        value: item,
                    };
                });
                setStatusFilterData(options);
            }
        } catch (error) {
            console.error("Error loading data:", error);
        }
    };


    const fetchOwnerFilterData = async () => {
        try {
            const apiResponse = await projectsApis.getOwnersFilterData(
                derivedProjectStatus
            );
            const { data, status } = apiResponse;
            if (status) {
                const options = data.map((item: any) => {
                    return {
                        label: item.userName,
                        value: item.userId,
                    };
                });
                setOwnerFilterData(options);
            }
        } catch (error) {
            console.error("Error loading data:", error);
        }
    };

    useEffect(() => {
        fetchStatusFilterData();
        fetchOwnerFilterData();
        dispatch(
            updateMenuData([
                {
                    text: "Task Issue Tracker",
                    link: "/pms/task-issue-tracker",
                },
            ])
        );
    }, []);
    return (
        <>
            <Template1
                moduleKey={window.location.pathname}
                columns={columns}
                pageTitle='Task Issue Tracker'
                pageDescription=''
                previousPath={{
                    link: "/pms/project/reports",
                    state: location.state,
                }}
                filters={{
                    defaultFilters: {
                        dateRange: {
                            title: "Custom Date Range",
                        },
                    },
                    customFilters: [
                        {
                            type: "multiple_selection",
                            name: "phaseStatus",
                            label: "Status",
                            options: statusFilterData,
                        },
                        {
                            type: "multiple_selection",
                            name: "UserId",
                            label: "Users",
                            options: ownerFilterData,
                        },
                    ]
                }}
            />
        </>
    )
};

export default TaskIssueTracker;
